import moment from "moment";
import EventsEmitter from "events/EventsEmitter";
import * as Utils from "services/UtilsService";

export default class TimelineActions extends EventsEmitter {
    static CreateProductMap(
        projectId: string,
        objects: any,
        workflows: any,
        workflowGroups: any,
        workflowItems: any,
        productMap: any,
        index: number,
        sortBy?: string
    ) {
        //console.log("projectId:", projectId);
        for (let i in objects) {
            var object: any = objects[i];
            if (object["type"] === "PROJECT" && typeof object["workflow"] !== "undefined") {
                productMap[projectId] = {};
                //console.log("project:", object["name"], "has workflow");
                let workflowStr = object["workflow"];
                workflowStr = atob(workflowStr);
                var workflow = JSON.parse(workflowStr);
                workflows[projectId] = workflow;
                index = this.addItemsToGroup(
                    projectId,
                    workflow,
                    workflowGroups,
                    productMap[projectId],
                    index - 1,
                    projectId + "-0",
                    0
                );
                this.addItems(projectId, workflow, objects, workflowItems, productMap[projectId], sortBy);
            }
        }
        return index;
    }

    static addItemsToGroup(
        projectId: string,
        track: any,
        groups: any,
        productMap: any,
        lastId: number,
        parentId: string,
        level: number
    ) {
        lastId = lastId + 1;
        let isRoot: boolean = typeof track.tracks != "undefined" && track.tracks.length > 0;
        groups.push({
            id: projectId + "-" + lastId,
            project: projectId,
            level: level,
            icon: track.icon,
            title: track.name,
            parent: parentId,
            root: true,
        });
        productMap[track.id] = lastId;
        if (isRoot) {
            parentId = projectId + "-" + lastId;
            for (let i in track.tracks) {
                let subtrack = track.tracks[i];
                lastId = this.addItemsToGroup(projectId, subtrack, groups, productMap, lastId, parentId, level + 1);
            }
        } else {
            let newId = lastId + 1;
            productMap[track.id + ":version"] = newId;
            groups.push({
                id: projectId + "-" + newId,
                project: projectId,
                level: level,
                icon: track.icon,
                version: true,
                title: "Versions",
                parent: projectId + "-" + lastId,
                root: false,
            });
            lastId = newId;
        }
        return lastId;
    }
    static createWorkflowMap(track: any, workflowMap: any) {
        workflowMap[track.id] = track;
        for (let i in track.tracks) {
            let subtrack = track.tracks[i];
            this.createWorkflowMap(subtrack, workflowMap);
        }
    }

    static addItems(
        projectId: string,
        workflow: any,
        projectEntities: any,
        items: any,
        productMap: any,
        sortBy?: string
    ) {
        let trackMap: any = {};

        const getTracks = () => {
            for (let i in projectEntities) {
                let entity = projectEntities[i];
                if (typeof entity["version_label"] != "undefined") {
                    // it is a version initially
                    let isVersion = true;
                    let currentFolder = entity;
                    const date_filter = sortBy ? sortBy : "file_date";
                    const start_date: number = parseInt(entity[date_filter]);
                    let activation_date: number = entity["completion_time"]
                        ? parseInt(entity["completion_time"]) + 1000
                        : start_date;
                    let capture_date: number = entity["completion_time"]
                        ? parseInt(entity["completion_time"]) + 1000
                        : entity["capture_date"]
                        ? parseInt(entity["capture_date"])
                        : parseInt(entity["capture_date"]);
                    if (typeof entity["version_active_date"] != "undefined")
                        activation_date = parseInt(entity["version_active_date"]);
                    let isActive = typeof activation_date !== "undefined";
                    while (
                        typeof currentFolder != "undefined" &&
                        currentFolder !== null &&
                        typeof currentFolder["workflow_product"] != "undefined" &&
                        currentFolder["workflow_product"] !== null
                    ) {
                        let productId = currentFolder["workflow_product"];
                        let productIndexId = isVersion ? productId + ":version" : productId;
                        let versionGroupId = productMap[productIndexId];
                        //starts here

                        let trackVersions: any = [];
                        if (typeof trackMap[productIndexId] == "undefined") {
                            trackMap[productIndexId] = trackVersions;
                        } else {
                            trackVersions = trackMap[productIndexId];
                        }
                        if (typeof versionGroupId !== "undefined") {
                            if (isVersion || (!isVersion && isActive)) {
                                let workflow = entity["workflow_product"];
                                if (typeof productMap[workflow] !== "undefined") {
                                    //console.log("**********entry here ");
                                    //console.log("activation_date:", activation_date);
                                    let version = {
                                        entity_id: i,
                                        is_version: isVersion,
                                        group: versionGroupId,
                                        start_date: start_date,
                                        activation_date: activation_date,
                                        activation_date_end: moment.now(),
                                        capture_date: capture_date,
                                        entity: entity,
                                    };
                                    //console.log("productId:", productId, "|version:", version);
                                    trackVersions.push(version);
                                }
                            }
                        }
                        //ends here
                        let parent_folder = currentFolder["file_folder"];
                        currentFolder = projectEntities[parent_folder];
                        isVersion = false;
                    }
                    // add version to top track
                    let trackVersions: any = [];
                    if (typeof trackMap[workflow.id] == "undefined") {
                        trackMap[workflow.id] = trackVersions;
                    } else {
                        trackVersions = trackMap[workflow.id];
                    }
                    if (isActive) {
                        // for top group 0
                        let workflow = entity["workflow_product"];
                        if (typeof productMap[workflow] !== "undefined") {
                            let version = {
                                entity_id: i,
                                is_version: false,
                                group: projectId + "-" + productMap[workflow],
                                start_date: start_date,
                                activation_date: activation_date,
                                activation_date_end: moment.now(),
                                capture_date: capture_date,
                                entity: entity,
                            };
                            //console.log("newVersion:", version);
                            trackVersions.push(version);
                        }
                    }
                }
            }
        };
        const getItems = () => {
            let lastId: number = 0;

            for (let i in trackMap) {
                let track = trackMap[i];
                track = Utils.sortArrayByProp(track, "activation_date");
                let trackGroupId: number = productMap[i];
                for (let j = 0; j < track.length - 1; j++) {
                    let item = track[j];
                    let nextItem = track[j + 1];
                    item.activation_date_end = nextItem.activation_date - 2;
                    lastId++;
                    let newItem: any = {
                        id: projectId + "-" + lastId,
                        group: projectId + "-" + trackGroupId,
                        entity_id: item.entity_id,
                        title: item.entity["version_number"],
                        product_folder_id: item.entity["file_folder"],
                        projectId: projectId,
                        is_version: item.is_version,
                        start_time: item.activation_date,
                        end_time: nextItem.activation_date - 2,
                    };
                    items.push(newItem);
                }
                if (track.length > 0) {
                    let item = track[track.length - 1];
                    lastId++;
                    let newItem = {
                        id: projectId + "-" + lastId,
                        group: projectId + "-" + trackGroupId,
                        entity_id: item.entity_id,
                        product_folder_id: item.entity["file_folder"],
                        projectId: projectId,
                        title: item.entity["version_number"],
                        is_version: item.is_version,
                        start_time: item.activation_date,
                        end_time: moment.now(),
                    };
                    //console.log("trackGroupId:", trackGroupId, "|newItem:", newItem);
                    items.push(newItem);
                }
            }
        };
        const processWorkflowMap = () => {
            let workflowMap: any = {};
            this.createWorkflowMap(workflow, workflowMap);
            for (let i in items) {
                let item = items[i];
                let entity = projectEntities[item.entity_id];
                if (entity && entity["workflow_product"]) {
                    let trackType = workflowMap[entity["workflow_product"]];
                    item.trackType = trackType;
                }
            }
        };
        getTracks();
        //console.log("trackMap:", trackMap);
        getItems();
        //console.log("before.items:", items);
        processWorkflowMap();
    }
    static resize(arr: any, newSize: number, defaultValue: boolean) {
        while (newSize > arr.length) arr.push(defaultValue);
        arr.length = newSize;
        return arr;
    }

    static getPath(entity: any, entities: any) {
        let path: any = [entity.name];
        let curEntity = entity;
        while (curEntity && curEntity["file_folder"] && curEntity["file_folder"] !== "0") {
            let folderId = curEntity["file_folder"];
            curEntity = entities[folderId];
            if (curEntity) {
                path.push(curEntity["name"]);
            }
        }
        path = path.reverse();
        return path;
    }
}
